import React from 'react';
import { Link } from 'react-router-dom';

export default function Authenticity() {
  return (
    <div className="bg-[#FAF8F5] min-h-screen text-[#2B1810]">
      {/* Standardized Long-Width Panoramic Banner */}
      <section className="relative min-h-[220px] sm:min-h-[250px] lg:min-h-[270px] overflow-hidden border-b border-[#3A332E] flex items-end">
        <img
          src="/assets/authenticity_banner.jpg"
          alt="Official Certificate of Authenticity and pure Mysore sandalwood heartwood timber testing"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="relative mx-auto flex min-h-[220px] sm:min-h-[250px] lg:min-h-[270px] max-w-7xl items-end px-5 pb-7 sm:pb-8 pt-12 text-white w-full z-10">
          <div className="max-w-2xl space-y-1.5">
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.25em] text-[#C49A45] block">
              100% Purity & Legal Provenance
            </span>
            <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight text-white drop-shadow-md">
              Authenticity & Quality
            </h1>
            <p className="max-w-xl text-xs sm:text-sm leading-relaxed text-[#EEE8E1] line-clamp-2 drop-shadow">
              Every piece of sandalwood timber is legally harvested under Karnataka Forest Department oversight with certified laboratory testing.
            </p>
          </div>
        </div>
      </section>

      {/* Main Authenticity Content */}
      <div className="max-w-5xl mx-auto px-4 py-12 space-y-10">

        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-lg border border-[#E8DFD8] shadow-sm space-y-3">
            <div className="w-12 h-12 rounded-full bg-[#F5EFEB] flex items-center justify-center text-[#C49A45]">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
            <h3 className="font-heading text-lg font-bold text-[#2B1810]">Legally Licensed Sourcing</h3>
            <p className="text-xs text-[#8A796C] leading-relaxed">
              We source our sandalwood exclusively from government-regulated plantations and licensed farmers adhering to Indian Forest Department guidelines.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg border border-[#E8DFD8] shadow-sm space-y-3">
            <div className="w-12 h-12 rounded-full bg-[#F5EFEB] flex items-center justify-center text-[#C49A45]">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                <path d="M14 2v6h6"/>
                <path d="M16 13H8"/>
                <path d="M16 17H8"/>
              </svg>
            </div>
            <h3 className="font-heading text-lg font-bold text-[#2B1810]">Authenticity Card Included</h3>
            <p className="text-xs text-[#8A796C] leading-relaxed">
              Every package comes with a serial-numbered Certificate of Authenticity certifying pure heartwood content and natural aromatic oil quality.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg border border-[#E8DFD8] shadow-sm space-y-3">
            <div className="w-12 h-12 rounded-full bg-[#F5EFEB] flex items-center justify-center text-[#C49A45]">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
              </svg>
            </div>
            <h3 className="font-heading text-lg font-bold text-[#2B1810]">No Synthetic Fragrances</h3>
            <p className="text-xs text-[#8A796C] leading-relaxed">
              Our products rely 100% on the natural essential oil within the sandalwood timber. No artificial perfume sprays or synthetic chemicals.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
